import { render, staticRenderFns } from "./IndexReportCaseStudy.vue?vue&type=template&id=33a8bd3b"
import script from "./IndexReportCaseStudy.vue?vue&type=script&lang=js"
export * from "./IndexReportCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./IndexReportCaseStudy.vue?vue&type=style&index=0&id=33a8bd3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports